module.exports = __webpack_public_path__ + "img/logo_inline.92b2c8c3.svg";